import "./tab.component.css";

import { Paper, Tabs } from "@mantine/core";
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import BreadcrumbLayout1 from "../../../_base/component/_layout/_breadcrumb";
import WarehouseLocationList from "../../Warehouse/WarehouseLocationList/WarehouseLocationList";
import DMBranch from "./DMBranch/DMBranch";
import DMInventory from "./DMInventory/DMInventory";
import { DMInventoryGroup } from "./DMInventoryGroup/DMInventoryGroup";
import DMReasonReturn from "./DMReasonReturn/DMReasonReturn";

/**
 * Tab đang mở được lưu trên url dạng ?tab=... để refresh (F5) không bị nhảy về tab đầu,
 * và để copy/gửi link mở đúng tab.
 */
const TAB_BRANCH = "branch";
const TAB_INVENTORY = "inventory";
const TAB_POSITION = "warehouse-location-list";
const TAB_INVENTORY_GROUP = "inventory-groups";
const TAB_REASON_RETURN = "reasonreturn";

const TABS: string[] = [
  TAB_BRANCH,
  TAB_INVENTORY,
  TAB_POSITION,
  TAB_INVENTORY_GROUP,
  TAB_REASON_RETURN,
];

const GeneralData = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const tabParam = searchParams.get("tab");
  // Tham số lạ hoặc chưa có thì rơi về tab đầu tiên
  const activeTab = tabParam && TABS.includes(tabParam) ? tabParam : TAB_BRANCH;

  // Ghi tab mặc định lên url để lần refresh sau vẫn vào đúng trang
  useEffect(() => {
    if (tabParam === activeTab) return;
    const next = new URLSearchParams(searchParams);
    next.set("tab", activeTab);
    setSearchParams(next, { replace: true });
  }, [tabParam, activeTab, searchParams, setSearchParams]);

  const handleChangeTab = (value: string | null) => {
    const next = new URLSearchParams(searchParams);
    next.set("tab", value && TABS.includes(value) ? value : TAB_BRANCH);
    setSearchParams(next);
  };

  return (
    <>
      <div
        style={{
          border: "1px solid #dee2e6",
          padding: "0px 10px",
        }}
      >
        <BreadcrumbLayout1></BreadcrumbLayout1>
      </div>
      <Paper shadow="md" radius="lg">
        <Tabs p={"xs"} value={activeTab} onChange={handleChangeTab}>
          <Tabs.List>
            <Tabs.Tab value={TAB_BRANCH}>Danh mục chi nhánh</Tabs.Tab>
            <Tabs.Tab value={TAB_INVENTORY}>Danh mục kho</Tabs.Tab>
            <Tabs.Tab value={TAB_POSITION}>Danh mục vị trí kho</Tabs.Tab>
            <Tabs.Tab value={TAB_INVENTORY_GROUP}>Phân loại kho</Tabs.Tab>
            <Tabs.Tab value={TAB_REASON_RETURN}>Lý do trả hàng</Tabs.Tab>
          </Tabs.List>

          <Tabs.Panel value={TAB_BRANCH}>
            {activeTab === TAB_BRANCH ? <DMBranch /> : <></>}
          </Tabs.Panel>

          <Tabs.Panel value={TAB_INVENTORY}>
            {activeTab === TAB_INVENTORY ? (
              <DMInventory hideBreadcrumb />
            ) : (
              <></>
            )}
          </Tabs.Panel>

          <Tabs.Panel value={TAB_POSITION}>
            {activeTab === TAB_POSITION ? (
              <WarehouseLocationList hideBreadcrumb />
            ) : (
              <></>
            )}
          </Tabs.Panel>

          <Tabs.Panel value={TAB_INVENTORY_GROUP}>
            {activeTab === TAB_INVENTORY_GROUP && <DMInventoryGroup />}
          </Tabs.Panel>

          <Tabs.Panel value={TAB_REASON_RETURN}>
            {activeTab === TAB_REASON_RETURN ? <DMReasonReturn /> : <></>}
          </Tabs.Panel>
        </Tabs>
      </Paper>
    </>
  );
};

export default GeneralData;
